import React from 'react';
import TableBadge from '@spark/ui-components/components/TanStackTable/components/TableBadge';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';
/**
 * Função para obter cores dos badges baseada na paleta
 */

const getBadgeVariant = value => {
  if (value === 'Sim') {
    return 'success';
  } else {
    return 'danger';
  }
};

const getStatusPatioBadgeVariant = (row) => {
  return row?.original?.statusPatioVariant || 'secondary';
};
/**
 * Colunas da tabela de disponibilidade usando TanStack Table
 */


export const getDisponibilidadeColumns = () => [{
  id: 'id',
  header: '#',
  accessorKey: 'id',
  size: 60,
  enableSorting: true,
  cell: ({
    getValue
  }) => <span>{getValue()}</span>
}, {
  id: 'data',
  header: 'Data',
  accessorKey: 'data',
  size: 120,
  enableSorting: true,
  cell: ({
    getValue
  }) => <span>{getValue()}</span>
}, {
  id: 'vazioem',
  header: 'Cidade vazio',
  accessorKey: 'vazioem',
  size: 140,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={12} />
}, {
  id: 'estado',
  header: 'Estado - UF',
  accessorKey: 'estado',
  size: 100,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={8} />
}, {
  id: 'frota',
  header: 'Frota',
  accessorKey: 'frota',
  size: 120,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={10} />
}, {
  id: 'veiculo',
  header: 'Veiculo',
  accessorKey: 'veiculo',
  size: 120,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={10} />
}, {
  id: 'tipoModelo',
  header: 'Tipo/Modelo',
  accessorKey: 'tipoModelo',
  size: 140,
  enableSorting: false,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={15} />
}, {
  id: 'motorista',
  header: 'Motorista',
  accessorKey: 'motorista',
  size: 150,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={12} />
}, {
  id: 'gestor',
  header: 'Gestor',
  accessorKey: 'gestor',
  size: 130,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={10} />
}, {
  id: 'statusPatio',
  header: 'Status Patio',
  accessorKey: 'statusPatioLabel',
  size: 200,
  enableSorting: true,
  cell: ({
    getValue,
    row
  }) => <TableBadge label={getValue()} variant={getStatusPatioBadgeVariant(row)} size="sm" />
}, {
  id: 'descargaPendente',
  header: 'Desc. Pendente',
  accessorKey: 'descargaPendente',
  size: 120,
  enableSorting: false,
  cell: ({
    getValue
  }) => <TableBadge label={getValue()} variant={getBadgeVariant(getValue())} size="sm" />
}, {
  id: 'vazio',
  header: 'Vazio',
  accessorKey: 'vazio',
  size: 80,
  enableSorting: false,
  cell: ({
    getValue
  }) => <TableBadge label={getValue()} variant={getBadgeVariant(getValue())} size="sm" />
}, {
  id: 'negociacao',
  header: 'Negociação',
  accessorKey: 'negociacao',
  size: 100,
  enableSorting: false,
  cell: ({
    getValue
  }) => <TableBadge label={getValue()} variant={getBadgeVariant(getValue())} size="sm" />
}, {
  id: 'coleta',
  header: 'Coleta',
  accessorKey: 'coleta',
  size: 80,
  enableSorting: false,
  cell: ({
    getValue
  }) => <TableBadge label={getValue()} variant={getBadgeVariant(getValue())} size="sm" />
}, {
  id: 'comercial',
  header: 'Comercial',
  accessorKey: 'comercial',
  size: 140,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={12} />
}, {
  id: 'destino',
  header: 'Destino',
  accessorKey: 'destino',
  size: 140,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={12} />
}, {
  id: 'disparados',
  header: 'Dias parados',
  accessorKey: 'disparados',
  size: 100,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={8} />
}, {
  id: 'diasAguardandoDescarga',
  header: 'Dias Aguardando Descarga',
  accessorKey: 'diasAguardandoDescarga',
  size: 160,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={15} />
}, {
  id: 'dataAgendamento',
  header: 'Data Agendamento',
  accessorKey: 'dataAgendamento',
  size: 140,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={12} />
}];
